import { render } from "./EditClassCred.vue?vue&type=template&id=b29bb438"
import script from "./EditClassCred.vue?vue&type=script&lang=js"
export * from "./EditClassCred.vue?vue&type=script&lang=js"

import "./EditClassCred.vue?vue&type=style&index=0&id=b29bb438&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__